import { render, staticRenderFns } from "./communicationSet.vue?vue&type=template&id=262acfc3&scoped=true&"
import script from "./communicationSet.vue?vue&type=script&lang=js&"
export * from "./communicationSet.vue?vue&type=script&lang=js&"
import style0 from "./communicationSet.vue?vue&type=style&index=0&id=262acfc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262acfc3",
  null
  
)

export default component.exports